import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import PropTypes from "prop-types";
import { Row, Col, Button, Container } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import _ from "lodash";
import {
  doFetchPopularProducts,
  doFetchRelatedProducts,
  updateActiveId
} from "../../actions/productAction";
import { isFromAppBrowser } from "../../utils";
import SneakerLoadingSpinner from "./SneakerLoadingSpinner";
import Sneaker from "./Sneaker";
import classNames from "classnames";
import { getCategoryName } from "Pages/Home/Helper/Formatter";

class LoadMoreBlock extends React.Component {
  render() {
    return (
      <div ref={this.props.innerRef} style={{ flex: 1 }}>
        <Col className={classNames({ "d-none": !this.props.show })}>
          <h3 className="text-center">Loading...</h3>
        </Col>
      </div>
    );
  }
}

LoadMoreBlock.propTypes = {
  innerRef: PropTypes.func
};
class Sneakers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      page: 1,
      prevY: 0,
      loading: true,
      hasMore: true,
      loadingMore: false,
      activeID: null,
      initialLoading: [1, 2, 3, 4]
    };
  }

  componentDidMount() {
    this.handleLoadItems(this.state.page);
    // this.props.getAllBrands();
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0
    };
    // const isInfiniteScrolL = !isFromAppBrowser();
    const isInfiniteScrolL = !isFromAppBrowser();
    this.setState({ isInfiniteScrolL });
    if (isInfiniteScrolL) {
      // Create an observer instance
      this.observer = new IntersectionObserver(
        this.handleObserver.bind(this), // pass the callback
        options
      );
      IntersectionObserver.prototype.POLL_INTERVAL = 100;
      this.observer.USE_MUTATION_OBSERVER = true;
      this.observer.observe(this.loadingRef);
    }
  }

  async handleObserver(entities, observer) {
    const y = entities[0].boundingClientRect.y;
    if (!this.props.dataProduct.isFetch && this.state.hasMore) {
      if (this.state.prevY > y) {
        await this.setState({ page: this.state.page, loading: true });
        this.handleLoadItems(this.state.page);
      }
      this.setState({ prevY: y });
    }
  }

  _handleNextPage = async () => {
    await this.setState({ page: this.state.page, loading: true });
    this.handleLoadItems(this.state.page);
  };

  handleLoadItems(page = 1, limit = 16) {
    const { dataCategory } = this.props;
    let { fetch_related, productDetail } = this.props;
    let productId = productDetail ? productDetail.id : 0;

    return fetch_related
      ? productId
        ? this.props
          .getRelatedList(productId, {
            params: { page, limit, availables: true }
          })
          .then(() => this.setState({ loading: false }))
          .catch(() => this.setState({ loading: false }))
        : null
      : this.props.getList({
        params: { page, limit, availables: true, category: dataCategory, sort_by: 'most_popular' }
      });
  }
  componentDidUpdate(prevProps, prevState) {
    const { dataCategory } = this.props;
    if (
      prevProps.dataProduct.isProductFilter &&
      !this.props.dataProduct.isProductFilter
    ) {
      this.setState({
        items: this.props.dataProduct.data
      });
    }
    if (prevProps.dataProduct.isFetch && !this.props.dataProduct.isFetch) {
      if (this.props.dataProduct.data.length > 0) {
        const { items } = this.state;
        this.setState({
          items:
            this.props.dataProduct.current_page !== 1
              ? [...items, ...this.props.dataProduct.data]
              : [...this.props.dataProduct.data],
          hasMore:
            this.props.dataProduct.next_page_url !== null &&
            this.props.dataProduct.current_page < 5,
          page: this.props.dataProduct.current_page + 1,
          loadingMore: true,
          prevY: 585,
          loading: this.props.dataProduct.isFetch
        });
      } else {
        this.setState({
          items: [],
          hasMore: false,
          prevY: 0,
          loading: this.props.dataProduct.isFetch
        });
      }
    }
    if (prevProps.dataCategory !== dataCategory)
      this.setState(
        {
          page: 1,
          prevY: 0,
          loading: true,
          hasMore: true,
          loadingMore: false
        },
        () => {
          this.props.getList({
            params: {
              page: this.state.page,
              availables: true,
              limit: 16,
              category: dataCategory
            }
          });
        }
      );
  }

  dataSource() {
    let { fetch_related } = this.props;

    if (this.state.items.length === 0 && !this.props.dataProduct.isFetch) {
      return fetch_related ? (
        <p style={{ textAlign: "center", width: "100%" }}>
          Tidak ada produk terkait
        </p>
      ) : (
        <Container className="page-container">
          <div style={{ flex: 1 }}>
            <div
              className="error-search-message"
              style={{ width: 300, margin: "15px auto" }}
            >
              <h1 className="text-center" style={{ color: "#000" }}>
                404 Not Found
              </h1>
              <h5 className="text-center" style={{ color: "#000" }}>
                Sneaker tidak ditemukan
              </h5>
            </div>
          </div>
        </Container>
      );
    }

    const categoryUrl =
      this.props.dataCategory === "apparels" ||
        this.props.dataCategory === "Apparels"
        ? "apparel"
        : this.props.dataCategory === "handbags" ? "luxury" : this.props.dataCategory;

    return this.state.items.map((item, index) => (
      <Sneaker
        {...item}
        category={categoryUrl}
        key={index}
        updateActiveId={this.props.updateActiveId}
        activeId={this.props.activeId}
        outOfStock={true}
        productDetail={this.props.productDetail}
        similarProducts={this.props.similarProducts}
        brandSlug={_.get(item, "product.brand.slug")}
      />
    ));
  }

  render() {
    const categoryUrl =
      this.props.dataCategory === "apparels" ||
        this.props.dataCategory === "Apparels"
        ? "apparel"
        : this.props.dataCategory === "handbags" ? "luxury" : this.props.dataCategory;
    return (
      <div id={`${this.props.newId}`} className="product-list">
        <Row id="product">{this.dataSource()}</Row>
        <Row id="toogle" className="browse__all__wrap flex-column">
          {!this.state.isInfiniteScrolL ? (
            <Col xs={12} md={12} style={{ paddingTop: "1rem" }}>
              <div className="d-flex justify-content-center">
                <Button
                  block
                  size={"lg"}
                  type="button"
                  onClick={this._handleNextPage}
                  className={classNames("button-load-more browse__all", {
                    "d-none": this.state.loading || !this.state.hasMore
                  })}
                >
                  Load More
                </Button>
              </div>
            </Col>
          ) : null}
          <Col xs={12} md={12} style={{ paddingTop: "1rem" }}>
            <Link to={`/search/${getCategoryName(categoryUrl)}`}>
              <Button
                block
                size={"lg"}
                className={classNames("button-load-more browse__all", {
                  "d-none": this.state.hasMore
                })}
              >
                View More
              </Button>
            </Link>
          </Col>
          <SneakerLoadingSpinner
            isLoading={this.state.loading}
            isHide={!this.state.hasMore}
            wrapperRef={loadingRef => (this.loadingRef = loadingRef)}
          />
        </Row>

        {/* <div
                      ref={loadingRef => (this.loadingRef = loadingRef)}
                      style={loadingTextCSS}
                    >
                      <Container style={{ margin: 0 }} fluid className="page-container">
                        <Row>
                          {
                            this.state.initialLoading.map((item, index) => (
                              <Col key={index} md={4} lg={3} xs={6} className="is__progresss">
                                <div className="is__progresss_header">
                                  <div className="item_top" />
                                </div>
                                <div className="is__progresss_center">
                                  <h3 style={{ visibility: 'hidden' }}>Image</h3>
                                </div>
                                <div className="is__progresss_footer">
                                  <h3 style={{ visibility: 'hidden' }}>Title</h3>
                                </div>
                              </Col>
                            ))
                          }
                        </Row>
                      </Container>
                    </div> */}

        {/* <Waypoint onEnter={this.handleNextPage}>
                    <LoadMoreBlock show={this.props.isFetch}/>
                </Waypoint> */}
        {/* <InfiniteScroll className="row product-list" threshold={250}
                    // pageStart={0}
                    // loadingMore={this.state.loadingMore}
                    showLoader={true}
                    items={this.dataSource()}
                    loadMore={this.handleNextPage.bind(this)}
                    hasMore={this.state.hasMore}
                    loader={<div className="loader">Loading ...</div>}/> */}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getList: query => dispatch(doFetchPopularProducts(query)),
    getRelatedList: (productId, query) =>
      dispatch(doFetchRelatedProducts(productId, query)),
    // getAllBrands: () => dispatch(getAllBrands()),
    updateActiveId: (id) => dispatch(updateActiveId(id))
  };
};

const mapStateToProps = state => {
  return {
    dataCategory: state.dataCategory.selected,
    dataProduct: state.dataProduct.products,
    activeId: state.dataProduct.activeId,
    productDetail: state.dataProduct.productDetails
    // isInfiniteScrolL: !state.loginReferralReducer.loginReferral.isWebApp
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sneakers);
